import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip as ChartTooltip,
  Legend,
} from "chart.js";

import { usePlayerStats } from "./hooks/usePlayerStats";
import PlayerStatsPlayer from "./PlayerStatsPlayer";
import PlayerStatsGoalkeeper from "./PlayerStatsGoalkeeper";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  ChartTooltip,
  Legend
);
const PlayerStats = ({
  playerData,
  playerId,
  seasonStats,
  seasonOptions,
  selectedSeasonId,
  setSelectedSeasonId,
  statsLoading,
  ratingChartData,
  selectedMatch,
  ratingsLoading,
  ratingsError,
}) => {
  // Determine if player is a goalkeeper based on position
  const position =
    playerData?.player?.role?.code2 ||
    playerData?.player?.role?.code3 ||
    playerData?.player?.role?.name;
  const isGoalkeeper =
    position === "GK" || position === "GKP" || position === "Goalkeeper";

  const statsProps = {
    seasonStats,
    seasonOptions,
    selectedSeasonId,
    setSelectedSeasonId,
    statsLoading,
    ratingChartData,
    selectedMatch,
    ratingsLoading,
    ratingsError,
  };

  // Conditionally render goalkeeper or player stats
  if (isGoalkeeper) {
    return <PlayerStatsGoalkeeper {...statsProps} />;
  }

  return <PlayerStatsPlayer {...statsProps} />;
};

export default PlayerStats;
